<template>
  <a-tag
    color="green"
    v-if="
      status === 'Approved' ||
      status === 'Aktif' ||
      status === 'Active' ||
      status === 'Verified' ||
      status === 'Transferred' ||
      status === 'Assigne' ||
      status === 'Created' ||
      status === 'File Have Been Uploaded' ||
      status === 'Open'
    "
    >{{ status.toUpperCase() }}</a-tag
  >
  <a-tag
    color="green"
    v-else-if="status === 'Release' || status === 'RELEASE'"
    >{{ status.toUpperCase() }}</a-tag
  >
  <a-tag
    color="blue"
    v-else-if="status === 'Delivered' || status === 'Received'"
    >{{ status.toUpperCase() }}</a-tag
  >
  <a-tag
    color="blue"
    v-else-if="status === 'Done' || status === 'DONE'"
    >{{ status.toUpperCase() }}</a-tag
  >
  <a-tag
    color="orange"
    v-else-if="
      status === 'On Process' || status === 'Waiting' || status === 'Edited'
      || status === 'on delivery'
    "
    >{{ status.toUpperCase() }}</a-tag
  >
  <a-tag
    color="red"
    v-else-if="
      status === 'Rejected' ||
      status === 'Revised' ||
      status === 'Non Aktif' ||
      status === 'Non Active' ||
      status === 'Cancelled' ||
      status === 'Canceled' ||
      status === 'Refunded'
    "
    >{{
      status == "Canceled" ? "Cancelled".toUpperCase() : status.toUpperCase()
    }}</a-tag
  >
  <a-tag v-else-if="status === 'Draft'">{{ status.toUpperCase() }}</a-tag>
  <a-tag
    v-else-if="status === 'Tutup' || status === 'Closed' || status === 'Close'"
    >CLOSED</a-tag
  >
  <a-tag color="red" v-else-if="status === null">CORRUPT</a-tag>
  <a-tag :color="color" v-else>{{ status }}</a-tag>
</template>

<script>
export default {
  name: "status",
  props: {
    color: String,
    status: String,
  },
};
</script>
